import React from 'react';
import { Checkbox } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { BathroomLocationOptions } from '@search/filter-enums/enums/BathroomLocation';
import {
    ElectricityOptions,
    GasOptions,
    HeatingOptions,
    SewerageOptions,
    WaterOptions
} from '@search/filter-enums/enums';

import { MobileFilter2 } from '../../filter/MobileFilter2';
import { HeatingFilter, SupplyOptionsFilter, BathroomLocationFilter } from '../../../models/Filter';

import './style.css';

const cn = classname.bind(null, 'MoreFilterView');

interface ISupplyOptionsButtonFilterView {
    supplyFilter: SupplyOptionsFilter;
    heatingFilter?: HeatingFilter;
    bathroomLocationFilter: BathroomLocationFilter;
    handleChangeSupply: (filter: [SupplyOptionsFilter, HeatingFilter]) => void;
    handleChange: (filter: BathroomLocationFilter) => void;
    classNameGroup?: string;
    isMobile?: boolean;
}

enum SupplyOptionsView {
    electricity,
    gas,
    water,
    sewerage,
    heating
}

export const SupplyOptionsButtonFilterView: React.FC<ISupplyOptionsButtonFilterView> = ({
    supplyFilter,
    heatingFilter,
    bathroomLocationFilter,
    handleChange,
    handleChangeSupply,
    classNameGroup,
    isMobile = false
}) => {
    const onChangeSupplyOptions = React.useCallback((newValue: boolean, option: SupplyOptionsView) => {
        const gas = new Set(supplyFilter.gas);
        const water = new Set(supplyFilter.water);
        const electricity = new Set(supplyFilter.electricity);
        const sewerage = new Set(supplyFilter.sewerage);
        const heating = new Set(heatingFilter?.heating);

        if (option === SupplyOptionsView.water) water[newValue ? 'add' : 'delete'](WaterOptions.HAS_ANY);
        if (option === SupplyOptionsView.sewerage) sewerage[newValue ? 'add' : 'delete'](SewerageOptions.HAS_ANY);
        if (option === SupplyOptionsView.heating) heating[newValue ? 'add' : 'delete'](HeatingOptions.HAS_ANY);
        if (option === SupplyOptionsView.gas) gas[newValue ? 'add' : 'delete'](GasOptions.HAS_ANY);
        // eslint-disable-next-line max-len
        if (option === SupplyOptionsView.electricity) electricity[newValue ? 'add' : 'delete'](ElectricityOptions.HAS_ANY);

        handleChangeSupply([
            new SupplyOptionsFilter(
                Array.from(gas),
                Array.from(water),
                Array.from(electricity),
                Array.from(sewerage)
            ),
            new HeatingFilter(
                Array.from(heating)
            )
        ]);
    }, [ handleChange, supplyFilter, heatingFilter ]);

    const onChangeBathroomLocation = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new BathroomLocationFilter([ BathroomLocationOptions.INSIDE ]));
        else handleChange(new BathroomLocationFilter());
    }, [ handleChange ]);

    const filter = (<div className={classNameGroup}>
        <div className={cn('item')}>
            <Checkbox
                key={SupplyOptionsView.sewerage}
                name='sewerage'
                value={supplyFilter.sewerage.includes(SewerageOptions.HAS_ANY)}
                onChange={newValue => onChangeSupplyOptions(newValue, SupplyOptionsView.sewerage)}
                variant='filter'
                block
            >
                Канализация
            </Checkbox>
        </div>
        <div className={cn('item')}>
            <Checkbox
                key={SupplyOptionsView.electricity}
                name='electricity'
                value={supplyFilter.electricity.includes(ElectricityOptions.HAS_ANY)}
                onChange={newValue => onChangeSupplyOptions(newValue, SupplyOptionsView.electricity)}
                variant='filter'
                block
            >
                Электричество
            </Checkbox>
        </div>
        <div className={cn('item')}>
            <Checkbox
                key={SupplyOptionsView.gas}
                name='gas'
                value={supplyFilter.gas.includes(GasOptions.HAS_ANY)}
                onChange={newValue => onChangeSupplyOptions(newValue, SupplyOptionsView.gas)}
                variant='filter'
                block
            >
                Газ
            </Checkbox>
        </div>
        <div className={cn('item')}>
            <Checkbox
                key={SupplyOptionsView.water}
                name='water'
                value={supplyFilter.water.includes(WaterOptions.HAS_ANY)}
                onChange={newValue => onChangeSupplyOptions(newValue, SupplyOptionsView.water)}
                variant='filter'
                block
            >
                Вода
            </Checkbox>
        </div>
        {heatingFilter && (<>
            <div className={cn('item')}>
                <Checkbox
                    key={SupplyOptionsView.heating}
                    name='heating'
                    value={heatingFilter.heating.includes(HeatingOptions.HAS_ANY)}
                    onChange={newValue => onChangeSupplyOptions(newValue, SupplyOptionsView.heating)}
                    variant='filter'
                    block
                >
                    Отопление
                </Checkbox>
            </div>
            <div className={cn('item')}>
                <Checkbox
                    key='bathroomLocation'
                    name='bathroomLocation'
                    value={(bathroomLocationFilter.locations ?? []).includes(BathroomLocationOptions.INSIDE)}
                    onChange={onChangeBathroomLocation}
                    variant='filter'
                    block
                >
                    Санузел в доме
                </Checkbox>
            </div>
        </>)}
    </div>);

    return isMobile ? (
        <MobileFilter2 filterTitle='Коммуникации'>
            {filter}
        </MobileFilter2>
    ) : filter;
};
